<template>
    <div class="background">
        <div class="introduction-up">
            <div
                style="
                    height: 80%;
                    flex-direction: column;
                    justify-content: space-between;
                "
            >
                <span class="title"
                    >{{ productInfo.proname }}
                    <span class="cplx">{{
                        productInfo.product_type
                    }}</span></span
                >
                <p class="fbjg">{{ productInfo.logindept }}</p>
                <div class="spxqBox">
                    <a-row>
                        <a-col :span="5"
                            ><div>
                                <p
                                    v-if="
                                        productInfo.rateMin == 0 &&
                                        productInfo.rateMax != 0
                                    "
                                    class="nll"
                                >
                                    不高于{{ productInfo.rateMax }}%
                                </p>
                                <p
                                    v-else-if="
                                        productInfo.rateMin != 0 &&
                                        productInfo.rateMax == 0
                                    "
                                    class="nll"
                                >
                                    {{ productInfo.rateMin }}%起
                                </p>
                                <p
                                    v-else-if="
                                        productInfo.rateMin == 0 &&
                                        productInfo.rateMax == 0
                                    "
                                    class="nll"
                                >
                                    面议
                                </p>
                                <p v-else class="nll">
                                    {{ productInfo.rateMin }}~{{
                                        productInfo.rateMax
                                    }}%
                                </p>
                            </div>
                            <p class="introduce">
                                <img src="../../assets/img/nll.png" alt="" />
                                <span
                                    v-if="
                                        productInfo.product_type == '保险产品'
                                    "
                                    >保费费率</span
                                >
                                <span v-else>年利率(单利)</span>
                            </p>
                        </a-col>
                        <a-col :span="5"
                            ><div>
                                <p class="dkxq">
                                    {{ productInfo.loanDeadlineMin }}-{{
                                        productInfo.loanDeadlineMax
                                    }}个月
                                </p>
                            </div>
                            <p class="introduce">
                                <img src="../../assets/img/dkqx.png" alt="" />
                                <span
                                    v-if="
                                        productInfo.product_type == '担保产品'
                                    "
                                    >担保期限</span
                                >
                                <span
                                    v-if="
                                        productInfo.product_type == '保险产品'
                                    "
                                    >承保期限</span
                                >
                                <span
                                    v-if="
                                        productInfo.product_type == '金融产品'
                                    "
                                    >贷款期限</span
                                >
                            </p></a-col
                        >
                        <a-col :span="5"
                            ><div>
                                <p class="edfw">
                                    {{ productInfo.loanMin }}-{{
                                        productInfo.loanMax
                                    }}万元
                                </p>
                            </div>
                            <p class="introduce">
                                <img src="../../assets/img/edfw.png" alt="" />
                                <span
                                    v-if="
                                        productInfo.product_type == '保险产品'
                                    "
                                    >保额范围</span
                                >
                                <span v-else>额度范围</span>
                            </p></a-col
                        >
                        <a-col :span="5" class="lastCol"
                            ><div>
                                <p
                                    v-if="
                                        productInfo.approvalMin == 0 &&
                                        productInfo.approvalMax == 0
                                    "
                                    class="spsj"
                                >
                                    秒申秒贷
                                </p>
                                <p class="spsj" v-else>
                                    {{ productInfo.approvalMin }}~{{
                                        productInfo.approvalMax
                                    }}个工作日
                                </p>
                            </div>

                            <p class="introduce">
                                <img src="../../assets/img/spsj.png" alt="" />
                                <span>审批时间</span>
                            </p></a-col
                        >
                        <a-col :span="4"
                            ><a-button type="primary" @click="goMy" class="ljsqbut"
                                >立即申请</a-button
                            ></a-col
                        >
                    </a-row>
                </div>
            </div>
        </div>
        <div class="application-box">
            <p class="small-title">
                <span class="icon-title"></span>&nbsp;&nbsp;申请流程
            </p>

            <div class="steps">
                <a-steps labelPlacement="vertical">
                    <a-step status="finish">
                        <template slot="description">
                            <p>1.注册用户</p>
                        </template>
                        <template slot="icon">
                            <img src="../../assets/img/zcyh.png" alt="" />
                        </template>
                    </a-step>
                    <a-step status="finish">
                        <template slot="description">
                            <p>2.提交申请</p>
                            <div class="red"></div>
                        </template>
                        <template slot="icon">
                            <img src="../../assets/img/tjsq.png" alt="" />
                        </template>
                    </a-step>
                    <a-step status="finish">
                        <template slot="description">
                            <p>3.申请通过</p>
                        </template>
                        <template slot="icon">
                            <img src="../../assets/img/shtg.png" alt="" />
                        </template>
                    </a-step>
                    <a-step status="finish">
                        <template slot="description">
                            <p>4.获取额度</p>
                        </template>
                        <template slot="icon">
                            <img src="../../assets/img/hqed.png" alt="" />
                        </template>
                    </a-step>
                </a-steps>
            </div>
        </div>

        <div class="product-description">
            <p class="small-title">
                <span class="icon-title"></span>&nbsp;&nbsp;产品说明
            </p>
            <div class="list">
                <ul>
                    <li>
                        <p class="product-title">
                            <img
                                src="../../assets/img/cpjj.png"
                                alt=""
                            />产品简介
                        </p>
                        <p class="product-content">{{ productInfo.introduction }}
                        </p>
                    </li>
                    <li>
                        <p class="product-title">
                            <img
                                src="../../assets/img/zrtj.png"
                                alt=""
                            />准入条件
                        </p>
                        <p class="product-content" style="line-height:30px">{{ productInfo.access_conditions }}
                        </p>
                    </li>
                    <li>
                        <p class="product-title">
                            <img
                                src="../../assets/img/sydx.png"
                                alt=""
                            />适用对象
                        </p>
                        <p class="product-content">{{ productInfo.type }}</p>
                    </li>
                    <li>
                        <p class="product-title">
                            <img
                                src="../../assets/img/sxcl.png"
                                alt=""
                            />所需材料
                        </p>
                        <p class="product-content">{{ productInfo.materials }}
                        </p>
                    </li>
                    <li>
                        <p class="product-title">
                            <img
                                src="../../assets/img/spms.png"
                                alt=""
                            />审批模式
                        </p>
                        <p class="product-content">{{ productInfo.approval_model }}
                        </p>
                    </li>
                    <li>
                        <p class="product-title">
                            <img
                                src="../../assets/img/xgfy.png"
                                alt=""
                            />相关费用
                        </p>
                        <p class="product-content">{{ productInfo.cost }}</p>
                    </li>
                    <li>
                        <p class="product-title">
                            <img
                                src="../../assets/img/dblx.png"
                                alt=""
                            />担保类型
                        </p>
                        <p class="product-content">{{ productInfo.guarantee }}
                        </p>
                    </li>
                    <li>
                        <p class="product-title">
                            <img
                                src="../../assets/img/hkfs.png"
                                alt=""
                            />还款方式
                        </p>
                        <p class="product-content">{{ productInfo.repayment_mode }}
                        </p>
                    </li>
                    <li>
                        <p class="product-title">
                            <img
                                src="../../assets/img/fwdq.png"
                                alt=""
                            />服务地区
                        </p>
                        <p class="product-content">{{ productInfo.region }}</p>
                    </li>
                </ul>
            </div>
        </div>
        <directional ref="directional" />
    </div>
</template>

<script>
import { indexFindById, getSuccessList } from "@/api/finance/finance.js";
import { userStatus, accountLogin, sendcode } from "@/api/user";
import directional from "@/pages/product/directional.vue";
const columns = [
    {
        title: "企业名称",
        dataIndex: "companyName",
        key: "companyName"
    },
    {
        title: "授信金额",
        dataIndex: "loanAmount",
        key: "loanAmount",
        scopedSlots: { customRender: "loanAmount" }
    },
    {
        title: "受理日期",
        dataIndex: "acceptTime",
        key: "acceptTime"
    },
    {
        title: "放款日期",
        key: "loanTime",
        dataIndex: "loanTime"
    }
];

export default {
    name: "financeProduct_detail",
    components: {
        directional
    },
    data() {
        return {
            //还款方式标签
            repayment_modeList: [],
            //服务地区标签
            regionList: [],
            //担保类型标签
            guaranteeList: [],
            productId: "",
            productInfo: {},
            successList: [],
          specialAreaList: [],
            total: 0,
            columns,
            visible: false,
            confirmLoading: false,
            form: this.$form.createForm(this),
            disabled: false,
            buttonText: "发送验证码",
            wait: 60
        };
    },

    beforeRouteEnter: function (to, from, next) {
        next((vm) => {
            vm.id = to.query.id;
            vm.init(vm.id);
        });
    },

    methods: {
        init(id) {
            this.productId = id;
            //获取搜索条件
            indexFindById({ id: id }).then((res) => {
                this.productInfo = res.data.data.financeProduct;
              let flag = this.productInfo.specialArea != null && this.productInfo.specialArea != undefined && this.productInfo.specialArea != '' ;
              if(flag){
                getTypes("003010").then(res => {
                  this.$ajaxAfter(res).then(() => {
                    this.specialAreaList = res.data.data.list;
                    this.productInfo.specialArea = this.specialAreaList.find(item=>item.param === this.productInfo.specialArea).desc;
                  });
                })
              }
                let list = res.data.data.financeProduct.region.split("|");
                let list2 =
                    res.data.data.financeProduct.repayment_mode.split("|");
                let list3 = res.data.data.financeProduct.guarantee.split("|");
                list.forEach((resp) => {
                    this.regionList.push(resp);
                });
                list2.forEach((resp) => {
                    this.repayment_modeList.push(resp);
                });
                list3.forEach((resp) => {
                    this.guaranteeList.push(resp);
                });
            });
            // .catch(() => {
            //     this.$message.error("服务器系统错误，请稍后重试！");
            // });

            getSuccessList(id)
                .then((res) => {
                    this.successList = res.data.data.successList;
                    this.total = res.data.data.total;
                })
                .catch(() => {
                    this.$message.error("服务器系统错误，请稍后重试！");
                });
        },

        goMy() {
            if (this.productInfo.product_type == "金融产品") {
                userStatus().then((res) => {
                    if (
                        res.data.success === "TRUE" &&
                        res.data.data.account &&
                        res.data.data.account.roleId == "1025"
                    ) {
                        let type = "企业";
                        if (this.$store.state.account.roleType == 6) {
                            type = "个人";
                        }
                        if (this.productInfo.type.indexOf(type) != -1) {
                            this.$refs.directional.financingDirectional(
                                this.productInfo
                            );
                        } else {
                            this.$message.error("该产品不适用于" + type);
                        }
                    } else {
                        window.open(
                            "http://auth.zwfw.hunan.gov.cn/oauth2/authorize?client_id=cp4zF99JSqG8YDD1wKjB4A&response_type=gov&scope=user.read&redirect_uri=http://credit.yueyang.gov.cn/xydapi/unifyLogin/syntony",
                            "_blank"
                        );
                      // this.$router.push({
                      //   name: "LoginCompany",
                      // });
                    }
                });
            } else {
                this.$message.warning("请线下联系发行机构");
            }
        },

        handleOk(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.confirmLoading = true;
                    accountLogin(values)
                        .then((res) => {
                            this.$ajaxAfter(res).then(() => {
                                this.$store
                                    .dispatch("setMenuAction")
                                    .then(() => {
                                        this.$router.push({
                                            name: "sm_mycapitalize_manage"
                                        });
                                    });
                            });
                        })
                        .catch(() => {
                            this.$message.error("服务器出错！请稍后再试!");
                            this.confirmLoading = false;
                        });
                }
            });
        },

        time() {
            if (this.wait == 0) {
                this.disabled = false;
                this.buttonText = "获取验证码";
                this.wait = 60;
            } else {
                this.disabled = true;
                this.buttonText = "重新发送(" + this.wait + ")";
                this.wait--;
                setTimeout(() => {
                    this.time();
                }, 1000);
            }
        }
    }
};
</script>

<style scoped lang="less">
.spxqBox {
    width: 100%;
    height: 70px;
    text-align: center;
    margin-top: 34px;
    p {
        width: 180px;
    }
    .nll,
    .dkxq,
    .edfw,
    .spsj {
        font-weight: bold;
        font-size: 24px;
        position: absolute;
        top: -16px;
        left: 50%;
        transform: translateX(-50%);
    }
    .nll {
        color: rgba(24, 144, 255, 1);
    }
    .dkxq {
        color: rgba(255, 126, 33, 1);
    }
    .edfw {
        color: rgba(51, 207, 202, 1);
    }
    .spsj {
        color: rgba(97, 167, 68, 1);
    }
    .ant-col {
        height: 40px;
        position: relative;
    }
    .introduce {
        position: absolute;
        bottom: -16px;
        left: 50%;
        transform: translateX(-50%);
        span {
            margin-left: 4px;
            font-size: 16px;
        }
    }
    .ant-col-5 {
        border-right: 1px solid rgba(24, 144, 255, 0.2);
    }
    .lastCol {
        border: none;
    }
}
.product-description,
.application-box {
    width: 1200px;
    background-color: #ffffff;
    padding: 20px;
    margin-bottom: 20px;
    .small-title {
        position: relative;
        font-weight: bold;
        font-size: 20px;
        .icon-title {
            display: inline-block;
            width: 4px;
            height: 16px;
            background: linear-gradient(
                to bottom,
                rgba(24, 144, 255, 0.1),
                rgba(24, 144, 255, 1)
            );
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
        }
    }
}
.application-box {
    height: 220px;
    .steps {
        margin: 40px auto 0px;
        width: 86%;
        p {
            color: rgba(51, 51, 51, 1);
            line-height: 36px;
            font-size: 16px;
        }
        /deep/ .ant-steps-label-vertical .ant-steps-item-tail {
            padding: 3.5px 44px;
        }
    }
}
.product-description {
    .list {
        margin-top: 14px;
        padding-left: 10px;
        li {
            padding: 16px 0px 20px;
            border-bottom: 1px solid rgba(238, 238, 238, 1);
        }
        .product-title {
            img {
                margin-right: 6px;
            }
            color: #1890ff;
            font-size: 18px;
            margin-bottom: 10px !important;
        }
        .product-content {
            padding-left: 22px;
            color: #333333;
            white-space: pre-wrap;
            font-size: 16px;
        }
    }
}
.background {
    width: 100%;
    background-color: #f5f5f5;
    position: relative;
    z-index: 1;
    margin: 102px 0 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.introduction-up {
    width: 1200px;
    min-height: 220px;
    background-color: #ffffff;
    border-radius: 2px;
    margin: 20px 0;
    padding: 20px;
    position: relative;
    .title{
        font-size: 32px;
    }
}
.cplx {
    color: #ff6600;
    background-color: #ffefe5;
    padding: 2px 7px;
    font-size: 14px;
}

.fbjg {
    color: #d6d4d4;
    font-size: 16px;
}
.ljsqbut{
    width: 131px;
    height: 40px;
    font-size: 16px;
}
</style>
